export default {
  'meta': {
    'langName': 'BULGARIAN',
    'lang': 'Български'
  },
  'title': 'ИЗТЕГЛЯНЕ НА ПРОДУКТ – БАСКЕТБОЛЕН КОШ B900 BOX NBA TARMAK',
  'description': 'Здравейте,\n\nНаскоро закупихте баскетболен кош Tarmak B900 BOX NBA от магазин DECATHLON. Благодарим Ви за доверието!\n\nВ рамките на нашия постоянен ангажимент към контрол на качеството и безопасността на продуктите екипът на DECATHLON идентифицира потенциален риск от вертикално падане на стълба, ако манивелата за регулиране на височината бъде премахната и след това продуктът бъде използван или преместван.\n\nМолим Ви да отговорите на няколко въпроса, за да можем да Ви предоставим подходящо решение за обезопасяване на Вашия продукт.\n\nМолим да ни извините за причиненото неудобство и Ви благодарим за доверието.\n\nЕкипът на DECATHLON\n\n',
  'emailConfirmation': {
    'title': 'Потвърдете имейл адреса си и държавата, в която живеете:'
  },
  'fields': {
    'country': 'Държава',
    'address': 'Имейл',
    'email': 'Имейл',
    'phonePrefix': 'Код на страната',
    'phone': 'Телефонен номер',
    'validations': {
      'phoneOrEmail': 'Моля, въведете имейл адрес или телефонен номер',
      'email': 'Въведете валиден имейл адрес',
      'phone': 'Въведете валиден телефонен номер'
    },
    'firstName': 'Фамилно име',
    'lastName': 'Собствено име',
    'deliveryAddress': 'Адрес ',
    'additionalAddress': 'Допълнение към адреса',
    'city': 'Град',
    'zip': 'Пощенски код',
    'choose': 'Избери',
    'required': 'Задължително поле'
  },
  'ownerCheck': {
    'title': 'Все още ли притежавате един или няколко баскетболни коша B900 BOX NBA?\n'
  },
  'yes': 'Да',
  'no': 'Не',
  'ownerChanged': {
    'title': 'Имате ли данни за контакт с настоящия собственик? ',
    'confirmation': 'Госпожо/Господине,\n\nБлагодарим Ви, че се включихте в тази процедура за гарантиране на качеството.\n\nМолим да ни извините за причиненото неудобство и Ви благодарим за доверието.\n\nЕкипът на DECATHLON'
  },
  'recall': {
    'title': 'Моля, посочете броя на баскетболните кошове, които притежавате, в зависимост от вида на монтираната манивела.',
    'descriptionRed': 'Баскетболен кош със сваляща се червена манивела',
    'descriptionBlack': 'Баскетболен кош с фиксирана черна манивела',
    'quantity': 'Количество',
    'notConcerned': 'Госпожо/Господине,\n\nБлагодарим Ви, че се включихте в тази процедура за гарантиране на качеството.\n\nВашият баскетболен кош Tarmak B900 BOX NBA не е засегнат от процедурата за изтегляне. Продуктът е безопасен и можете да го използвате спокойно.\n\nМолим да ни извините за причиненото неудобство и Ви благодарим за доверието.\n\nЕкипът на DECATHLON',
    'concernedProductQuantity': 'Брой на несъответстващите продукти:',
    'concernedProductLabel': 'Несъответстващ продукт:',
    'confirmation': 'Благодарим Ви, че попълнихте формуляра. Вашата заявка беше успешно регистрирана.\n\nЩе Ви изпратим номер за проследяване на доставката на комплекта възможно най-скоро (чрез FandiWeb за европейските страни / чрез X за страните извън Европа).\n\nС най-добри пожелания,\n\nЕкипът на DECATHLON'
  },
  'repair': {
    'title': 'Ремонт с Ваше участие',
    'description': 'При някои модели баскетболни кошове TARMAK B900 BOX NBA (арт. номер 4239136) установихме риск от вертикално падане на стълба, ако манивелата бъде премахната и продуктът бъде използван или преместван. \nВъз основа на Вашия отговор изглежда, че Вашият продукт попада в обхвата на този риск.\n\nЕто защо Ви молим незабавно да преустановите използването му и Ви предлагаме да Ви съдействаме да адаптирате манивелата, за да можете да използвате продукта си безопасно.\nБъдете спокойни - за този ремонт не е необходима специална подготовка. Всичко е подробно обяснено във видеото и в приложената инструкция по-долу:',
    'videoLink': 'Видео',
    'docLink': 'Инструкция',
    'callToAction': 'Кликнете тук, за да получите своя безплатен комплект за ремонт.',
    'warranty': 'Процедурата се покрива от нашата 5-годишна гаранция.'
  },
  'repairRequest': {
    'title': 'Моля, въведете следната информация, за да Ви изпратим безплатния ремонтен комплект на избран от Вас адрес:'
  },
  'form': {
    'submit': 'Напред'
  },
  'status': 'Translation validated by COUNTRY'
} as const
